import styled from "@emotion/styled";

export const FlyerDetailPageTabLayout = styled.div`
  display: block;
  width: 100%;
  padding: 32px;
`;
